// @ts-nocheck
import React, { ReactNode, ReactNodeArray, useEffect } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import SelfCareNavBarData from "../../../Models/Content/SelfCareNavBarBlockData";
import SelfCareActions from "./SelfCareActions";
import CommonTroubleShooting from "./CommonTroubleShooting";
import "./index.scss";
import { connect } from "react-redux";
import { selectTab } from "../SelfCareNavBarBlock/selfCareNavBarSlice";
import { Container } from "reactstrap";
import Loader from "../../Shared/LocalLoader/LocalLoader";
import { isBrowser, isMobile } from "react-device-detect";
import {
  getCustomerCoreProducts,
  setDesktopMode,
  setMobileMode,
} from "../SelfCareNavBarBlock/selfCareNavBarSlice";
import gaParams from "../../../utilities/analytics/constants";
import { gaEvent } from "../../../utilities/analytics/tracking";

interface SelfCareNavBarBlockState {
  selectedOption: "SELF_CARE" | "COMMON_TROUBLES";
}

export default class SelfCareNavBar extends EpiComponent<
  SelfCareNavBarData,
  SelfCareNavBarBlockState
> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return (
      <ConnectedNavBar context={this.getContext()} iContent={this.props.data} />
    );
  }
}

function NavBar({
  context,
  iContent,
  selectedTab,
  setSelectedTab,
  getCustomerCoreProducts,
  userServices,
  isLoading,
  setDesktopMode,
  setMobileMode,
  maxActions,
}) {
  const onTroublesClick = (event) => {
    event.preventDefault();
    setSelectedTab("COMMON_TROUBLES");
    gaEvent(
      gaParams.SELF_CARE_NAV_CLICK_ON_CHOOSE_TAB_OPTION.category,
      gaParams.SELF_CARE_NAV_CLICK_ON_CHOOSE_TAB_OPTION.eventType,
      "פתרון תקלות נפוצות",
    );
  };
  const onSelfCareClick = (event) => {
    event.preventDefault();
    setSelectedTab("SELF_CARE");
    gaEvent(
      gaParams.SELF_CARE_NAV_CLICK_ON_CHOOSE_TAB_OPTION.category,
      gaParams.SELF_CARE_NAV_CLICK_ON_CHOOSE_TAB_OPTION.eventType,
      "פעולות בשירות עצמי",
    );
  };

  useEffect(() => {
    async function fetchProducts() {
      await getCustomerCoreProducts();
      setSelectedTab("SELF_CARE");
    }
    fetchProducts();
  }, [isLoading]);

  useEffect(() => {
    if (isMobile) {
      setMobileMode();
    } else if (isBrowser) {
      setDesktopMode();
    }
  }, [selectedTab]);

  return (
    <div className="self-care-nav-bar-component-block">
      <Container className="upper-container">
        <div className="mainNavHeader">
          <div className="HowCanWeHelpHeader">מה היית רוצה לעשות?</div>
        </div>
        <div className="headersContainer">
          <div
            className={"headers selfCareActions " + selectedTab}
            onClick={onSelfCareClick}
          >
            {iContent.selfCareActionsTitle.value}
          </div>
          <div className="line"></div>
          <div
            className={"headers commonTroubleShooting " + selectedTab}
            onClick={onTroublesClick}
          >
            {iContent.commonTroubleShootingTitle.value}
          </div>
        </div>
      </Container>
      {isLoading ? (
        <div className="loader-container">
          <Loader />
        </div>
      ) : selectedTab === "COMMON_TROUBLES" ? (
        <Container className="bottom-container">
          <CommonTroubleShooting context={context} iContent={iContent} />
        </Container>
      ) : (
        <Container className="bottom-container">
          <SelfCareActions context={context} iContent={iContent}  />
        </Container>
      )}
    </div>
  );
}

const ConnectedNavBar = connect(
  (state: any) => ({
    selectedTab: state.selfCareNavBarBlock.selectedTab,
    userServices: state.selfCareNavBarBlock.userServices,
    isLoading: state.selfCareNavBarBlock.isLoading,
    maxActions: state.selfCareNavBarBlock.maxActions,
  }),
  (dispatch) => ({
    setSelectedTab: (tab) => dispatch(selectTab(tab)),
    getCustomerCoreProducts: () => dispatch(getCustomerCoreProducts()),
    setMobileMode: () => dispatch(setMobileMode()),
    setDesktopMode: () => dispatch(setDesktopMode()),
  }),
)(NavBar);
